<template>
	<div id="SIP-audio" v-if="visible" style="position: relative; z-index: 10">
		<el-button type="danger" v-if="useVoice != '2'" icon="el-icon-close" circle
			style="position: fixed; bottom: 180px; left: 280px; z-index: 200" @click="endConn"></el-button>
		<iframe v-if="useVoice != '2'" id="audioIframe" :src="'https://live.concoai.com/r/' + robotId" frameborder="0"
			allow="microphone;camera;midi;encrypted-media;" @load="iframeLoad" height="200px" width="300px"
			style="position: fixed; bottom: 0px; left: 0px"></iframe>
		<div id="remote-video" v-if="useVoice == '2'">
			<div style="position: absolute;top: 2px;left: 2px;width: calc(100% - 4px);height: calc(100% - 4px);display: flex;
			justify-content: center;
			align-items: center;
			flex-direction: column;">
				<div style="color: aliceblue;font-size: 1vw;">【 {{ robotName }} 】</div>
				<div style="color: aliceblue;font-size: 1vw;margin: 0.7vw 0;">当前通话</div>
				<div style="color: aliceblue;font-size: 1vw;">
					<span v-if="timeVo.hour < 10">0</span><span>{{ timeVo.hour }}</span> :
					<span v-if="timeVo.minute < 10">0</span><span>{{ timeVo.minute }}</span> :
					<span v-if="timeVo.second < 10">0</span><span>{{ timeVo.second }}</span>
				</div>
				<div class="closeCall" style="margin: 10px 0;" @click="endConn()">挂断</div>
			</div>
		</div>
	</div>
</template>

<script>
	// import NERTC from "nertc-web-sdk"

	import {
		webRtcToken,
		switchWebRtc
	} from '@/api/admin'
	import {
		getItem
	} from '@/utils/auth'
	export default {
		props: {
			visible: {
				type: Boolean,
				required: true
			},
			robotId: null,
			robotName: null,
			useVoice: null,
			robotType: null,
			ifSIP: null,
			role: null,
			activePhone: null
		},
		data() {
			return {
				languageJson: languageJson,
				closeImg: require('../../../static/img/close-phone.png'),
				webrtc: require('../../../static/img/webrtc.png'),
				appkey: '7e21cf5151b72ff8f9973233552fc00a',
				token: null,
				client: null,
				localStream: null,
				setInter: null,
				timeVo: {
					hour: 0,
					minute: 0,
					second: 0
				},
                webRtcConnection: null,
                userId: null,
			}
		},
		beforeDestroy() {
			let that = this
			if (that.useVoice == '2') {
				that.clearRtc()
				clearInterval(that.setInter)
			}
		},
		mounted() {
			let that = this
			if (that.useVoice == '2') {
				that.switchWebRtc("0")
				that.setInter = window.setInterval(function() {
					if (that.timeVo.second >= 60) {
						that.timeVo.second = 0
						that.timeVo.minute += 1
						if (that.timeVo.minute >= 60) {
							that.timeVo.minute = 0
							that.timeVo.hour += 1
						}
					} else {
						that.timeVo.second += 1
					}
				}, 1000)
			}
		},
		methods: {
			switchWebRtc(sType) {
				const that = this
				switchWebRtc({
					number: that.robotId,
					type: sType
				}).then(res => {
					if (sType == '0') {
						that.wYlogin()
					}
				})
			},
			listen(){
			    console.log(123)
			},
			wYlogin() {
				// let that = this

                // that.webRtcConnection.call()

				// 注册
				// that.client = NERTC.createClient({
				// 	appkey: that.appkey,
				// 	debug: false,
				// });
				// // 加入
				// that.client.join({
				// 	channelName: that.robotId + '_room',
				// 	uid: getItem('userInfo').phone,
				// 	token: that.token
				// }).then((obj) => {
				// 	that.initLocalStream()
				// })
				// // 监听 订阅对方
				// that.client.on('stream-added', async (evt) => {
				// 	const remoteStream = evt.stream;
				// 	remoteStream.setSubscribeConfig({
				// 		audio: true,
				// 		video: true,
				// 		screen: true
				// 	});
				// 	that.client.subscribe(remoteStream).then(() => {})
				// })
				// // 监听 对方媒体源
				// that.client.on('stream-subscribed', (evt) => {
				// 	const remoteStream = evt.stream;
				// 	const divt = document.getElementById('small')
				// 	const playOptions = {
				// 		audio: true,
				// 		video: true,
				// 		screen: true
				// 	}
				// 	remoteStream.play(divt, playOptions).then(() => {})
				// })
			},
			async initLocalStream() {
				const microphones = await NERTC.getMicrophones();
				let that = this
				that.localStream = NERTC.createStream({
					uid: getItem('userInfo').phone,
					audio: true,
					microphoneId: microphones.microphoneId,
					video: false
				})
				that.localStream.init().then(() => {
					let div = document.getElementById('container')
					that.localStream.play(div)
					that.client.publish(that.localStream).then(() => {})
				})
			},
			clearRtc() {
				const that = this
				// if (that.useVoice == '2') {
				// 	that.switchWebRtc("1")
				// 	// that.client.leave()
				// 	// that.client.destroy()
				// }
				// that.$emit("update:visible", false);
				// that.$emit("closeVoice", true);
				if (that.useVoice == '2') {
					that.switchWebRtc("1")
					// that.client.leave()
					// that.client.destroy()
				}
				that.$emit("update:visible", false);
			},
			endConn() {
				let that = this
				if (that.robotType == '07' && that.role == 'user') {
					if (that.activePhone) {
						that.exitMessage()
					} else {
						that.$emit("close", false);
					}
					// that.$emit("close", false);
				} else {
					that.exitMessage()
				}
				// that.$confirm("此操作将结束语音通讯, 是否继续?", "提示", {
				// 	confirmButtonText: "结束",
				// 	cancelButtonText: "取消",
				// 	type: "warning",
				// }).then(() => {
				// 	that.clearRtc()
				// }).catch(() => {
				// 	that.$message({
				// 		type: "info",
				// 		message: "已取消",
				// 	});
				// });
			},
			exitMessage() {
				let that = this
				that.$confirm(that.languageJson.WantToContinue, that.languageJson.prompt, {
					confirmButtonText: that.languageJson.end,
					cancelButtonText: that.languageJson.Cancel,
					type: "warning",
				}).then(() => {
					that.clearRtc()
				}).catch(() => {
					that.$message({
						type: "info",
						message: that.languageJson.Canceled,
					});
				})
			}
		}
	}
</script>

<style scoped lang="less">
	#SIP-audio {
		.closeCall {
			width: 5vw;
			height: 1.5vw;
			line-height: 1.5vw;
			background: linear-gradient(132deg, rgba(203,50,46,0.8) 0%, #F55151 100%);
			box-shadow: 0px 1px 1px 0px #0F1A79;
			border-radius: 4px;
			border: 1px solid #ec2c52;
			font-size: 0.8vw;
			cursor: pointer;
		}
		#remote-video {
			background: url("../../../static/imgV2/loding.png") no-repeat !important;
			background-size: 100% !important;
			position: fixed;
			bottom: 0px;
			left: 0px;
			width: 13vw;
			height: 10vw;
			background-color: #2d2d2d;
			color: white;
			z-index: 2;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/audio/privateWebRtcAudio.vue